import { AxiosPromise }  from 'axios';
import { client }        from '@/service/client';
import { HeatMapValues } from '@/views/heat-map-configuration/heat-map-configuration.types';

export function getHeatMapConfiguration(): AxiosPromise {
  return client.get('/dashboard/heat-map-configuration');
}

export function putHeatMapConfiguration(heatMapConfiguration: HeatMapValues[]): AxiosPromise {
  return client.put('/dashboard/heat-map-configuration', {
    options: heatMapConfiguration,
  });
}
